// extracted by mini-css-extract-plugin
export default {"product_information":"ProductInfo_product_information__3r48t","product_information_title":"ProductInfo_product_information_title__5SXDl"};